import Notification from '@/models/Notification';
import api from '../_api';

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    notifications: [],
    isLoading: false,
  },
  // -----------------------------------------------------------------
  getters: {
    getNotifications: (state,) => state.notifications,
    isLoading: (state,) => state.isLoading,
  },
  // -----------------------------------------------------------------
  mutations: {
    setNotifications: (state, notifications,) => {
      state.notifications = notifications;
    },
    setLoading: (state, isLoading,) =>
      (state.isLoading = isLoading),
  },
  // -----------------------------------------------------------------
  actions: {
    fetchNotifications: ({ commit, }, filters,) => {
      commit('notifications/setLoading', true, { root: true, },);
      return api.getNotifications(filters,).then((response,) => {
        const items = response.data.data.map((item,) => new Notification(item,),);
        commit('setNotifications', { ...response.data, items, total_count: response.data.total, },);
        return {
          ...response.data,
          items,
        };
      },).catch((error,) => Promise.reject(error.response.data.errors,),).
        finally(() => {
          commit('notifications/setLoading', false, { root: true, },);
        },) ;
    },
  },
};
